import type { ReactNode } from 'react';

import HeaderTitle from './header-title.js';
import BackButton from '../../back-button/index.js';
import ToggleButton from '../../toggle-button/index.js';

type FixedHeaderProps = {
  title: ReactNode;
  onlyTitle?: boolean;
  onBack?: () => void;
};

function FixedHeader({ title, onlyTitle = false, onBack }: FixedHeaderProps) {
  return (
    <header className="flex size-full items-center">
      <div className="flex flex-1 items-center">
        {!onlyTitle && <BackButton onClick={onBack} />}
      </div>
      <HeaderTitle>{title}</HeaderTitle>
      <div className="flex flex-1 items-center justify-end">
        {!onlyTitle && !__STANDALONE_MODE__ && <ToggleButton />}
      </div>
    </header>
  );
}

export default FixedHeader;
